import { type PortfolioGreeks } from "#/types/accounts";

export const defaultGreeks: PortfolioGreeks = {
  delta: 0,
  gamma: 0,
  rho: 0,
  theta: 0,
  vega: 0,
};
